import _ from 'lodash'
import list from './list'
import history from './history'
import inspect from './inspect'
export default {
	namespaced: true,
	modules: {
		list,
		history,
		inspect,
	},
}
